declare namespace $ {

	export class $mol_icon_reload extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=reload.view.tree.d.ts.map